import { AxiosError } from "axios";

import { ICustomerCertificateResponse } from "features/ImportCertificate/interface";

import api from "services/api";
import { routers_constants } from "services/constants";

import { LogOperation } from "utils/entities/logOperation";

export interface ICustomerCertificateEntryData {
  customerId: number;
}

export interface ICustomerCertificateImportData {
  textCrypted: string;
}

export const CustomerCertificateService = {
  getAll: async (customerId: number) => {
    try {
      const { data } = await api.get<any>(
        `/v1/CustomerCertificate/GetByCustomerId?customerId=${customerId}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch {
      return {
        status: false,
        data: null,
        message: "Houve um erro ao consultar os registros.",
      };
    }
  },

  post: async (_authToken: string | null, customerCertificate: any) => {
    try {
      const body = {
        ...customerCertificate,
      };
      const { data } = await api.post<any>(`/v1/CustomerCertificate/Add`, body);

      return {
        status: true,
        data: data.data,
      };
    } catch {
      return {
        status: false,
        message: "Houve um erro ao cadastrar o certificado.",
      };
    }
  },

  importCertificate: async (textCrypted: string) => {
    try {
      const body = {
        textCrypted: textCrypted,
        device: LogOperation.getDevice(),
        ip: LogOperation.getMachineIP(),
        logPoliceUnitId: LogOperation.getPoliceUnitId(),
        logUserId: LogOperation.getUserId(),
      };
      const { data } = await api.post<any>(`/v1/CustomerCertificate/Import`, body);

      if (data.errors.length > 0 || data.ok === false) {
        return {
          status: false,
          message: "Certificado inválido.",
        };
      }

      return {
        status: true,
        data: data,
      };
    } catch {
      return {
        status: false,
        message: "Houve um erro ao atualizar o certificado.",
      };
    }
  },
  /**
   * O customer certificate tem o dado de tempo para demonstracao
   */
  getCustomerCertificate: async (customerId: number) => {
    if (!customerId) {
      return;
    }
    try {
      const { data } = await api.get<any>(
        `/v1/CustomerCertificate/GetByCustomerId`,
        {
          params: {
            customerId: customerId,
          },
        },
      );

      return data;
    } catch {
      return {
        status: false,
        message: "Houve um erro ao recuperar o certificado.",
      };
    }
  },
};

export const customerCertificateServicesV2 = {
  getCustomerCertificateByCustomerId: async ({
    customerId,
  }: ICustomerCertificateEntryData) => {
    try {
      const uri =
        routers_constants.customerCertificate.getCustomerCertificateByCustomerId(
          customerId,
        );
      const { data } = await api.get(uri);

      const returnCustomerCertificate: ICustomerCertificateResponse = data;
      return returnCustomerCertificate;
    } catch (error: any) {
      const errorReturn = error as AxiosError;
      const dataReturn = errorReturn.response
        ?.data as ICustomerCertificateResponse;
      return dataReturn;
    }
  },
  importCertificate: async ({
    textCrypted,
  }: ICustomerCertificateImportData) => {
    try {
      const uri =
        routers_constants.customerCertificate.importCustomerCertificateImport;
      const body = { textCrypted: textCrypted };
      const { data } = await api.post<any>(uri, body);

      const returnCustomerCertificate: ICustomerCertificateResponse = data;
      return returnCustomerCertificate;
    } catch (error) {
      const errorReturn = error as AxiosError;
      const dataReturn = errorReturn.response
        ?.data as ICustomerCertificateResponse;
      return dataReturn;
    }
  },
};
